import Icon from './Icon';

const ImageCrossLMP = (props) => (
  <Icon
    {...props}
    path="M45.297 40l32.35-32.35c0.662-0.711 1.023-1.651 1.006-2.623s-0.41-1.898-1.098-2.586c-0.687-0.687-1.614-1.081-2.585-1.098s-1.912 0.343-2.623 1.006l-32.35 32.35-32.35-32.35c-0.711-0.662-1.651-1.023-2.623-1.006s-1.898 0.411-2.586 1.098c-0.687 0.687-1.081 1.614-1.098 2.586s0.343 1.912 1.006 2.623l32.35 32.35-32.35 32.35c-0.702 0.703-1.097 1.656-1.097 2.65s0.394 1.946 1.097 2.65c0.703 0.702 1.656 1.096 2.65 1.096s1.947-0.395 2.65-1.096l32.35-32.35 32.35 32.35c0.704 0.702 1.656 1.096 2.65 1.096s1.947-0.395 2.65-1.096c0.703-0.704 1.097-1.656 1.097-2.65s-0.395-1.947-1.097-2.65l-32.35-32.35z"
    color="var(--color-text-primary)"
  />
);

export default ImageCrossLMP;
